<template>
  <div class="dataCenter_shujuji" style="height: 100%;">
    <!-- v-if="userRole == 'ADMIN'" -->
    <a-tabs v-model="activeKey" style="height: 100%;">
      <a-tab-pane key="1" tab="数据集">
        <Index></Index>
      </a-tab-pane>
      <a-tab-pane key="2" tab="授权客户" >
        <Authorize></Authorize>
      </a-tab-pane>
    </a-tabs>
    <!-- <Index v-else style="height: calc(100vh - 120px);"></Index> -->
  </div>
</template>

<script>
import Authorize from './data/Authorize'
import Index from './index'

export default {
  data() {
    return {
      activeKey: "1",
      userRole: null
    };
  },
  components: {
    Index,
    Authorize,
  },
  methods: {},
  created() {
    this.userRole = this.$store.state.user.roles.length && this.$store.state.user.roles[0].name || ''
  },
};
</script>
<style lang='less' scoped>
::v-deep .ant-tabs-bar {
  margin-bottom: 0;
}
</style>
